import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { visuallyHidden } from '@noths/polaris-client-styles';

import * as elementIds from 'src/components/organisms/Filter/constants/elementIds';
import { FilterOptionsContainer } from 'src/components/organisms/Filter/containers/FilterOptionsContainer';
import type { FilterWithFilterOptionsCount } from 'src/components/organisms/Filter/modules/selectors';
import * as styles from 'src/components/organisms/Filter/styles/FilterList.styles';
import { smallPill } from 'src/components/organisms/Filter/styles/smallPill.styles';

const VISIBILITY_THRESHOLD = 0.7;

interface Props {
  filter: FilterWithFilterOptionsCount;
  onFilterListItemVisibility: (filterUid: string) => void;
}

export const FilterListItem = ({ filter, onFilterListItemVisibility }: Props) => {
  const { observedElementRef: listItemRef } = useVisibilityObserver<HTMLLIElement>(
    () => onFilterListItemVisibility(filter.uid),
    { observerOptions: { threshold: VISIBILITY_THRESHOLD }, autoUnobserve: true },
  );

  return (
    <li css={styles.listItem} ref={listItemRef} data-testid={`listitem-${filter.title}`}>
      <h3 css={styles.filterHeading}>
        {filter.title}
        {filter.selectedFilterOptionsCount > 0 && (
          <>
            <span
              data-testid={elementIds.FILTER_LIST_ITEM_COUNT}
              css={[smallPill, styles.filterCount]}
            >
              {filter.selectedFilterOptionsCount}
            </span>
            <span css={visuallyHidden}> selected</span>
          </>
        )}
      </h3>
      <FilterOptionsContainer key={filter.uid} filter={filter} />
    </li>
  );
};
